import withAuth from "../../hoc/withAuth";
import { AuthLayout } from "../../layouts";
import { OrdersMain } from "../../organisms";

export const Orders = withAuth<{}>(() => {
  return (
    <AuthLayout title="Orders">
      <div>
        <OrdersMain />
      </div>
    </AuthLayout>
  );
});
